<script setup lang="ts">
import { LEGAL_FOOTER } from '@/content/legal'
</script>

<template>
  <footer class="mx-auto flex w-full max-w-6xl flex-col gap-3 border-t border-rule-soft px-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-6">
    <!-- Not `muted`: slate-500 falls under 4.5:1 on the warm paper of the landing and apply surfaces. -->
    <UIText variant="small">
      {{ LEGAL_FOOTER.disclaimer }}
    </UIText>

    <nav :aria-label="LEGAL_FOOTER.navLabel">
      <ul class="flex gap-5">
        <li v-for="link in LEGAL_FOOTER.links" :key="link.to">
          <UILink :to="link.to" variant="muted" class="inline-flex items-center gap-1">
            {{ link.label }}
            <UIIcon v-if="link.to.startsWith('http')" name="launch" size="xs" />
          </UILink>
        </li>
      </ul>
    </nav>
  </footer>
</template>
